import { useTranslation } from 'react-i18next'
import { PageLayout } from '@/components/layout/PageLayout'
import { PageHeader } from '@/components/layout/PageHeader'
import { TotalPointsChart } from './charts/TotalPointsChart'
import { ActionModulesDoneChart } from './charts/ActionModulesDoneChart'
import { AveragePointsChart } from './charts/AveragePointsChart'
import { PresenceQuotaChart } from './charts/PresenceQuotaChart'
import { TotalEmployeesCard } from './statistics/TotalEmployeesCard'
import { ActivatedAccountsCard } from './statistics/ActivatedAccountsCard'
import { TopPointsCard } from './statistics/TopPointsCard'
import { TopActionsCard } from './statistics/TopActionsCard'

export default function DashboardPage() {
  const { t } = useTranslation('dashboard')
  return (
    <PageLayout scrollEnabled>
      <PageHeader title={t('header.title')} description={t('header.description')} />
      <div className="flex flex-col gap-6">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          <TotalEmployeesCard />
          <ActivatedAccountsCard />
          <TopPointsCard />
          <TopActionsCard />
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
          <TotalPointsChart />
          <ActionModulesDoneChart />
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
          <AveragePointsChart />
          <PresenceQuotaChart />
        </div>
      </div>
    </PageLayout>
  )
}
